import { Component, Input } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { BetInputComponent } from "../bet-input/bet-input.component";

@Component({
  selector: 'app-bet-input-list',
  standalone: true,
  imports: [
    SharedModule,
    BetInputComponent
],
  templateUrl: './bet-input-list.component.html',
  styleUrl: './bet-input-list.component.scss'
})
export class BetInputListComponent {
	@Input() bets:string[] = [];
	public betQt:number = 15;

	public counter = () => new Array(this.betQt);

}
